import { app, Component, ojs } from "modular-openscriptjs";
import { pageInfo } from "../../helpers";
import { PAGES } from "../../declarations";
import Container from "../Blocks/Container";

const h = app("h");

ojs(Container);

export default class Page404 extends Component {
	render(...args) {
		pageInfo(PAGES.PAGE_404);

		return h.Container(
			{
				class: "d-flex flex-column align-items-center justify-content-center text-center py-5",
				style: "min-height: 70vh;",
			},

			// Large icon with gradient
			h.div(
				{
					class: "mb-4",
					style: "--fs: 5rem;",
				},
				h.i({
					class: "fas fa-compass",
					style: "animation: spin 4s linear infinite; display: inline-block; background: linear-gradient(135deg, #973e87 0%, #d946a6 50%, #973e87 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;",
				})
			),

			// 404 heading
			h.h1(
				{
					class: "display-1 fw-bold mb-3",
					style: "color: #973e87;",
				},
				"404"
			),

			// Message
			h.h2(
				{
					class: "h4 fw-500 text-dark mb-2",
				},
				"Page Not Found"
			),

			h.p(
				{
					class: "text-secondary mb-4",
					style: "max-width: 400px;",
				},
				"Oops! We couldn't find what you were looking for. The page you're trying to reach doesn't exist or has been moved."
			),

			// Home button
			h.button(
				{
					class: "btn btn-primary btn-lg px-4",
					style: "background: linear-gradient(-45deg, #973e87, #d946a6, #7a3270, #973e87); background-size: 400% 400%; animation: gradient 5s ease infinite; border: none;",
					onclick: h.func("app('router').to", "home"),
				},
				h.i({ class: "fas fa-home me-2" }),
				"Go Home"
			),

			...args
		);
	}
}
